module.exports = __webpack_public_path__ + "static/4-87a50b7616d1413660d76b5d05d04a54.jpeg";